module.exports = __webpack_public_path__ + "img/information_technology_thumbnail.f08248b9.jpg";